import React, { useEffect, useState } from "react";
import { Box, Flex, Spacer, useBreakpointValue, useDisclosure } from "@chakra-ui/react";
import { NotificationBadge, Menu as HamburgerIcon, Close } from "../../../assets/icons/components";
import { useContext } from "react";
import { AppContext } from "../../../context/ApplicationContext";
import { Constants } from "../constants";
import { Logo, ModalTemplate } from "../general";
import {  useLocation } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";
import { HeaderRightSection } from "./HeaderRightSection";
import { Badge } from "../general";
import WelcomeModal from "../../../pages/Courses/WelcomeModal";
import { useHistory } from "react-router-dom";
import useCleverTap, { CleverTapEvents, ScreenNames } from "../../../clevertap/useCleverTap";
import ReferralButton from "./ReferralButton";

interface Props {
  notifIconRequired?: boolean;
}
const Header = ({ notifIconRequired = false }: Props) => {
  const state = useContext(AppContext)[0];

  const desktopScreens = useBreakpointValue({ base: "none", md: "block" });
  const mobilescreens = useBreakpointValue({ base: "flex", md: "none" });
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(false); // Welcome modal
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();
  const clevertap = useCleverTap()[0];

  const location = useLocation();
  console.log("location:", location.pathname);
  useEffect(() => {
    if (state.profileData) {
      // if all mandatory field in profile filed or not
      const isProfileCompleted = [
        state.profileData?.email,
        state.profileData?.phone_number,
        state.profileData?.graduation_year,
        state.profileData?.date_of_birth,
        state.profileData?.job_after_graduation,
        state.profileData?.gender,
      ].every((el) => el !== "" && el !== null && el !== undefined);
      const showWelcomeModalLocalstorage = JSON.parse(
        localStorage.getItem("showWelcomeModal-" + state.profileData?.slug) as string
      );

      // if profile is incomplete and user hasnt decised to skip/continue the modal even once the modal will appear otherwise not
      if (!isProfileCompleted && showWelcomeModalLocalstorage === null) {
        setIsWelcomeModalOpen(true);
      } else {
        setIsWelcomeModalOpen(false);
      }
    }
  }, [state.profileData]);

  const onSkip = () => {
    clevertap.fireEvent(CleverTapEvents.click_profile_modal, {
      screen_name: ScreenNames.dashboardCourses,
      button_text: "skip",
      button_sequence: 1,
    });
    setIsWelcomeModalOpen(false);
    localStorage.setItem("showWelcomeModal-" + state.profileData?.slug, JSON.stringify(false));
  };
  const onContinue = () => {
    clevertap.fireEvent(CleverTapEvents.click_profile_modal, {
      screen_name: ScreenNames.dashboardCourses,
      button_text: "continue",
      button_sequence: 2,
    });
    setIsWelcomeModalOpen(false);
    localStorage.setItem("showWelcomeModal-" + state.profileData?.slug, JSON.stringify(false));
    history.push("/profile/edit");
  };
  const bottomLabelsList: {
    key: number;
    title: string;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    active: boolean;
    path: string;
    badgeComponent?: React.ReactElement;
    link?: string;
    isExternal?: boolean;
  }[] = [
    {
      key: 1,
      title: "Referral Program",
      type: "hamburger-label",
      active: true,
      path: "/referral-program",
      badgeComponent: <Badge variant="red" label="New" />,
    },
    {
      key: 2,
      title: "Documents",
      type: "hamburger-label",
      active: true,
      path: "/batch-docs",
      isExternal: false,
    },
    {
      key: 3,
      title: "PAP",
      type: "hamburger-label",
      active: true,
      path: "/isa",
      link: "https://masaischool.com/fees",
      isExternal: true,
    },
  ];

  const isProgramSwitchingRestricted: boolean = state.profileData?.is_program_switching_restricted
    ? true
    : false;
  return (
    <>
      <Box
        as="nav"
        boxShadow="outer"
        position="fixed"
        height={`${Constants.headerHeight}`}
        left={{
          base: 0,
          md: `${Constants.sidePanelWidth}`,
        }}
        top="0"
        bg="ms-primary"
        right={{
          base: "inherit",
          md: 0,
        }}
        width={{
          base: "full",
          md: "inherit",
        }}
      >
        <Flex h={"100%"} justifyContent="space-between">
          <Box
            display={mobilescreens}
            ml="ms-8"
            cursor="pointer"
            onClick={isOpen ? onClose : onOpen}
            mt={"16px"}
          >
            {isOpen ? <Close boxSize="6" /> : <HamburgerIcon boxSize="6" />}
          </Box>
          <button
            onClick={() => {
              window.open(
                state.isScholar ? "https://www.prepleaf.com" : "https://www.masaischool.com"
              );
            }}
          >
            <Box
              display={mobilescreens}
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              alignItems={"center"}
              w={"80%"}
              justifyContent={"space-around"}
            >
              <Box ml={"16px"}>
                <Logo />
              </Box>
            </Box>
          </button>

          <Spacer display={desktopScreens} />
          {true && (
            <Box d={{ base: "none", md: "flex" }} alignItems={"center"}>
              <ReferralButton />
            </Box>
          )}

          <Box id={"user-profile-desktop"} pr={{ base: "ms-18", md: "ms-24" }} alignSelf={"center"}>
            <Flex>
              {notifIconRequired && (
                <Box cursor="pointer" mr={{ base: "ms-16", md: "ms-24" }}>
                  <NotificationBadge boxSize="8" badge={true} badgecolor="#D61E27" />
                </Box>
              )}
              <HeaderRightSection username={state.profileData?.name} />
            </Flex>
          </Box>
        </Flex>
      </Box>
      <Box
        position={"fixed"}
        mt={Constants.headerHeight}
        display={isOpen ? "block" : "none"}
        width={"100%"}
      >
        <HamburgerMenu isOpen={isOpen} onClose={onClose} labelsList={bottomLabelsList} />
      </Box>
      {/* Keeping this modal close forever for now */}
      <ModalTemplate title="" isOpen={false} onClose={() => onSkip()} showCloseButtonIcon={false}>
        <WelcomeModal onSkip={onSkip} onContinue={onContinue} />
      </ModalTemplate>
    </>
  );
};

export default Header;
